import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid2';

const styles = () => ({
    tableCell: {
        flexShrink: 0,
        flexGrow: 1,
        display: 'flex',
        padding: '21px 16px',
        alignItems: 'center',
        '&:first-child': {
            paddingLeft: '24px',
        },
        '& p:not(.show-overflow), & a:not(.show-overflow)': {
            display: 'block',
            maxWidth: '100%',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            textWrap: 'nowrap',
        },
    },
    xs: {
        maxWidth: '6.166666%',
        flexBasis: '6.166666%',
    },
});

function ListViewBodyCell({ classes, children, size = 1, key, uniqueKey, ...rest }) {
    return (
        <Grid
            key={`${uniqueKey}-${key}`}
            size={size}
            className={[classes.tableCell, size === 0.5 && classes.xs]}
            {...rest}
        >
            {children}
        </Grid>
    );
}

export default withStyles(styles)(ListViewBodyCell);
